import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';

export default function SimpleSearch( { query, setQuery, className = ''} 
: 
{ query:any; setQuery:any; className?:string } ){
  return (
    <div className={"relative flex items-center "+className}>
      <MagnifyingGlassIcon className="h-4 w-4 absolute left-2 text-slate-400" />
      <input
        className="border border-slate-300 bg-slate-50 rounded h-10 lg:h-8 placeholder:text-slate-400 px-2 pl-7 w-full"
        placeholder="Search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
    </div>
  )
}
